import { gql } from '@apollo/client';

export const CREATE_DATANORM_REQUEST_MAIL = gql`
    mutation CreateDatanormRequestMail($datanormRequestMailInput: DatanormRequestMailInputType!) {
        createDatanormRequestMail(datanormRequestMailInput: $datanormRequestMailInput)
    }
`;
